import { useGetAuthenticatedUser } from 'Flux/Selector/index.js'
import type { CustomMenuItemProps } from './MenuItems.js'
import { DocumentPlusIcon } from '@heroicons/react/16/solid'
import { TooltipTrigger } from '../../../Provider/TooltipManager.js'
import React from 'react'
import { isSubscriptionInactive } from '../../../Model/User/IUser.js'

export const CreateOrderMenuItem = (props: CustomMenuItemProps) => {
  const user = useGetAuthenticatedUser()
  const cancelled = !!user && isSubscriptionInactive(user.org)

  const wrapWithModal = (handler: () => void) => {
    if (user) return handler
    return () => (document.getElementById('signup-modal') as HTMLDialogElement)?.showModal()
  }

  return (
    <li
      id="tour-sidebar-order-creation"
      className="text-base flex flex-col relative gap-x-3 cursor-pointer rounded-md px-2 py-1.5 mb-1 whitespace-nowrap hover:bg-gray-300"
    >
      <div className="flex items-center gap-x-3">
        <DocumentPlusIcon className="w-6 h-6 shrink-0" /> {/* <-- Consistent icon style */}
        <span>Create Order</span>
      </div>

      {/* Sub-buttons only if sidebar open */}
      <div className={`flex flex-col gap-1 mt-1 ml-9`}>
        {/* Indent to align nicely under text */}
        <TooltipTrigger
          classNames={'inline-block h-[1.5em]'}
          tooltip={
            cancelled
              ? 'Your subscription is no longer active. Please resubscribe to create orders.'
              : 'Choose this if you have fastq files and can provide all information such as primers. The order may then be claimed by a customer.'
          }
        >
          <button
            data-testid="order-normal"
            className="btn btn-xs btn-outline w-full text-left"
            onClick={wrapWithModal(() => props.onNavigate$.next('/createOrderLab'))}
            disabled={cancelled}
          >
            Using FASTQ <span className="text-xs text-gray-500 ">raw data</span>
          </button>
        </TooltipTrigger>
        <TooltipTrigger
          classNames={'inline-block h-[1.5em]'}
          tooltip={
            cancelled
              ? 'Your subscription is no longer active. Please resubscribe to create orders.'
              : 'Choose this if you only have sample metadata and need a lab to generate fastq files.'
          }
        >
          <button
            data-testid={'order-draft'}
            className="btn btn-xs btn-outline w-full text-left"
            onClick={wrapWithModal(() => props.onNavigate$.next('/createOrderCustomer'))}
            disabled={cancelled}
          >
            Prepare Order <span className="text-xs text-gray-500 ">for Lab</span>
          </button>
        </TooltipTrigger>
      </div>
    </li>
  )
}
